// src/data/StaticCardMapping.js - AUTO-GENERATED FILE
// Generated on: 2025-08-29T13:04:21.596Z
// Total Cards: 520
// Source: /Applications/XAMPP/xamppfiles/htdocs/bumfit/app/frontend/public/assets/cards

export const STATIC_CARD_ORDER = [
  {
    "position": 1,
    "id": "card_001",
    "image": "battle_v1_framed.png",
    "folder": "battle-cards",
    "pack": "Pack1"
  },
  {
    "position": 2,
    "id": "card_002",
    "image": "battle_v2_framed.png",
    "folder": "battle-cards",
    "pack": "Pack1"
  },
  {
    "position": 3,
    "id": "card_003",
    "image": "battle_v3_framed.png",
    "folder": "battle-cards",
    "pack": "Pack1"
  },
  {
    "position": 4,
    "id": "card_004",
    "image": "battle_v4_framed.png",
    "folder": "battle-cards",
    "pack": "Pack1"
  },
  {
    "position": 5,
    "id": "card_005",
    "image": "battle_v5_framed.png",
    "folder": "battle-cards",
    "pack": "Pack1"
  },
  {
    "position": 6,
    "id": "card_006",
    "image": "battle_v6_framed.png",
    "folder": "battle-cards",
    "pack": "Pack1"
  },
  {
    "position": 7,
    "id": "card_007",
    "image": "battle_v7_framed.png",
    "folder": "battle-cards",
    "pack": "Pack1"
  },
  {
    "position": 8,
    "id": "card_008",
    "image": "battle_v8_framed.png",
    "folder": "battle-cards",
    "pack": "Pack1"
  },
  {
    "position": 9,
    "id": "card_009",
    "image": "battle_v9_framed.png",
    "folder": "battle-cards",
    "pack": "Pack1"
  },
  {
    "position": 10,
    "id": "card_010",
    "image": "battle_v10_framed.png",
    "folder": "battle-cards",
    "pack": "Pack1"
  },
  {
    "position": 11,
    "id": "card_011",
    "image": "battle_v11_framed.png",
    "folder": "battle-cards",
    "pack": "Pack1"
  },
  {
    "position": 12,
    "id": "card_012",
    "image": "battle_v12_framed.png",
    "folder": "battle-cards",
    "pack": "Pack1"
  },
  {
    "position": 13,
    "id": "card_013",
    "image": "battle_v13_framed.png",
    "folder": "battle-cards",
    "pack": "Pack1"
  },
  {
    "position": 14,
    "id": "card_014",
    "image": "battle_v14_framed.png",
    "folder": "battle-cards",
    "pack": "Pack1"
  },
  {
    "position": 15,
    "id": "card_015",
    "image": "battle_v15_framed.png",
    "folder": "battle-cards",
    "pack": "Pack1"
  },
  {
    "position": 16,
    "id": "card_016",
    "image": "battle_v16_framed.png",
    "folder": "battle-cards",
    "pack": "Pack1"
  },
  {
    "position": 17,
    "id": "card_017",
    "image": "battle_v17_framed.png",
    "folder": "battle-cards",
    "pack": "Pack1"
  },
  {
    "position": 18,
    "id": "card_018",
    "image": "battle_v18_framed.png",
    "folder": "battle-cards",
    "pack": "Pack1"
  },
  {
    "position": 19,
    "id": "card_019",
    "image": "battle_v19_framed.png",
    "folder": "battle-cards",
    "pack": "Pack1"
  },
  {
    "position": 20,
    "id": "card_020",
    "image": "battle_v20_framed.png",
    "folder": "battle-cards",
    "pack": "Pack1"
  },
  {
    "position": 21,
    "id": "card_021",
    "image": "battle_v21_framed.png",
    "folder": "battle-cards",
    "pack": "Pack1"
  },
  {
    "position": 22,
    "id": "card_022",
    "image": "battle_v23_framed.png",
    "folder": "battle-cards",
    "pack": "Pack1"
  },
  {
    "position": 23,
    "id": "card_023",
    "image": "battle_v24_framed.png",
    "folder": "battle-cards",
    "pack": "Pack1"
  },
  {
    "position": 24,
    "id": "card_024",
    "image": "battle_v26_framed.png",
    "folder": "battle-cards",
    "pack": "Pack1"
  },
  {
    "position": 25,
    "id": "card_025",
    "image": "battle_v27_framed.png",
    "folder": "battle-cards",
    "pack": "Pack1"
  },
  {
    "position": 26,
    "id": "card_026",
    "image": "battle_v29_framed.png",
    "folder": "battle-cards",
    "pack": "Pack1"
  },
  {
    "position": 27,
    "id": "card_027",
    "image": "battle_v30_framed.png",
    "folder": "battle-cards",
    "pack": "Pack1"
  },
  {
    "position": 28,
    "id": "card_028",
    "image": "battle_v31_framed.png",
    "folder": "battle-cards",
    "pack": "Pack1"
  },
  {
    "position": 29,
    "id": "card_029",
    "image": "battle_v32_framed.png",
    "folder": "battle-cards",
    "pack": "Pack1"
  },
  {
    "position": 30,
    "id": "card_030",
    "image": "battle_v33_framed.png",
    "folder": "battle-cards",
    "pack": "Pack1"
  },
  {
    "position": 31,
    "id": "card_031",
    "image": "battle_v34_framed.png",
    "folder": "battle-cards",
    "pack": "Pack1"
  },
  {
    "position": 32,
    "id": "card_032",
    "image": "battle_v36_framed.png",
    "folder": "battle-cards",
    "pack": "Pack1"
  },
  {
    "position": 33,
    "id": "card_033",
    "image": "battle_v37_framed.png",
    "folder": "battle-cards",
    "pack": "Pack1"
  },
  {
    "position": 34,
    "id": "card_034",
    "image": "battle_v38_framed.png",
    "folder": "battle-cards",
    "pack": "Pack1"
  },
  {
    "position": 35,
    "id": "card_035",
    "image": "battle_v40_framed.png",
    "folder": "battle-cards",
    "pack": "Pack1"
  },
  {
    "position": 36,
    "id": "card_036",
    "image": "battle_v41_framed.png",
    "folder": "battle-cards",
    "pack": "Pack1"
  },
  {
    "position": 37,
    "id": "card_037",
    "image": "battle_v42_framed.png",
    "folder": "battle-cards",
    "pack": "Pack1"
  },
  {
    "position": 38,
    "id": "card_038",
    "image": "battle_v43_framed.png",
    "folder": "battle-cards",
    "pack": "Pack1"
  },
  {
    "position": 39,
    "id": "card_039",
    "image": "battle_v44_framed.png",
    "folder": "battle-cards",
    "pack": "Pack1"
  },
  {
    "position": 40,
    "id": "card_040",
    "image": "battle_v45_framed.png",
    "folder": "battle-cards",
    "pack": "Pack1"
  },
  {
    "position": 41,
    "id": "card_041",
    "image": "battle_v47_framed.png",
    "folder": "battle-cards",
    "pack": "Pack1"
  },
  {
    "position": 42,
    "id": "card_042",
    "image": "battle_v48_framed.png",
    "folder": "battle-cards",
    "pack": "Pack1"
  },
  {
    "position": 43,
    "id": "card_043",
    "image": "battle_v49_framed.png",
    "folder": "battle-cards",
    "pack": "Pack1"
  },
  {
    "position": 44,
    "id": "card_044",
    "image": "battle_v50_framed.png",
    "folder": "battle-cards",
    "pack": "Pack1"
  },
  {
    "position": 45,
    "id": "card_045",
    "image": "battle_v51_framed.png",
    "folder": "battle-cards",
    "pack": "Pack1"
  },
  {
    "position": 46,
    "id": "card_046",
    "image": "battle_v52_framed.png",
    "folder": "battle-cards",
    "pack": "Pack1"
  },
  {
    "position": 47,
    "id": "card_047",
    "image": "battle_v53_framed.png",
    "folder": "battle-cards",
    "pack": "Pack1"
  },
  {
    "position": 48,
    "id": "card_048",
    "image": "battle_v54_framed.png",
    "folder": "battle-cards",
    "pack": "Pack1"
  },
  {
    "position": 49,
    "id": "card_049",
    "image": "battle_v55_framed.png",
    "folder": "battle-cards",
    "pack": "Pack1"
  },
  {
    "position": 50,
    "id": "card_050",
    "image": "battle_v56_framed.png",
    "folder": "battle-cards",
    "pack": "Pack1"
  },
  {
    "position": 51,
    "id": "card_051",
    "image": "battle_v57_framed.png",
    "folder": "battle-cards",
    "pack": "Pack1"
  },
  {
    "position": 52,
    "id": "card_052",
    "image": "battle_v58_framed.png",
    "folder": "battle-cards",
    "pack": "Pack1"
  },
  {
    "position": 53,
    "id": "card_053",
    "image": "battle_v59_framed.png",
    "folder": "battle-cards",
    "pack": "Pack1"
  },
  {
    "position": 54,
    "id": "card_054",
    "image": "battle_v60_framed.png",
    "folder": "battle-cards",
    "pack": "Pack1"
  },
  {
    "position": 55,
    "id": "card_055",
    "image": "battle_v65_framed.png",
    "folder": "battle-cards",
    "pack": "Pack1"
  },
  {
    "position": 56,
    "id": "card_056",
    "image": "battle_v66_framed.png",
    "folder": "battle-cards",
    "pack": "Pack1"
  },
  {
    "position": 57,
    "id": "card_057",
    "image": "battle_v67_framed.png",
    "folder": "battle-cards",
    "pack": "Pack1"
  },
  {
    "position": 58,
    "id": "card_058",
    "image": "battle_v87_framed.png",
    "folder": "battle-cards",
    "pack": "Pack1"
  },
  {
    "position": 59,
    "id": "card_059",
    "image": "battle_0163e65b-2d92-4926-bb40-30f3c29d95da_framed.png",
    "folder": "battle-cards",
    "pack": "Pack1"
  },
  {
    "position": 60,
    "id": "card_060",
    "image": "battle_05f90cb4-5bd4-4178-b54a-66155ee151a5_framed.png",
    "folder": "battle-cards",
    "pack": "Pack1"
  },
  {
    "position": 61,
    "id": "card_061",
    "image": "battle_0617f9d2-6c1e-40c6-873c-526cd2f44547_framed.png",
    "folder": "battle-cards",
    "pack": "Pack2"
  },
  {
    "position": 62,
    "id": "card_062",
    "image": "battle_091ea3fa-9969-4e97-bfbb-9bf5e8bb33dd_framed.png",
    "folder": "battle-cards",
    "pack": "Pack2"
  },
  {
    "position": 63,
    "id": "card_063",
    "image": "battle_10f651f6-8534-43e3-9c77-4199d997c876_framed.png",
    "folder": "battle-cards",
    "pack": "Pack2"
  },
  {
    "position": 64,
    "id": "card_064",
    "image": "battle_11430b69-21d1-4f23-a8a3-10f61860ba64_framed.png",
    "folder": "battle-cards",
    "pack": "Pack2"
  },
  {
    "position": 65,
    "id": "card_065",
    "image": "battle_124ddda0-214b-40fc-a54e-40c274afc6ac_framed.png",
    "folder": "battle-cards",
    "pack": "Pack2"
  },
  {
    "position": 66,
    "id": "card_066",
    "image": "battle_13dcd784-d282-447c-ba2a-17cc30d00d93_framed.png",
    "folder": "battle-cards",
    "pack": "Pack2"
  },
  {
    "position": 67,
    "id": "card_067",
    "image": "battle_143c5ebf-afda-410e-ba2d-b79b0b392545_framed.png",
    "folder": "battle-cards",
    "pack": "Pack2"
  },
  {
    "position": 68,
    "id": "card_068",
    "image": "battle_1a4a8d4f-44d2-48d9-8d4a-cad31bd28df5_framed.png",
    "folder": "battle-cards",
    "pack": "Pack2"
  },
  {
    "position": 69,
    "id": "card_069",
    "image": "battle_1d319c31-6916-41c5-9734-8da457b8abd6_framed.png",
    "folder": "battle-cards",
    "pack": "Pack2"
  },
  {
    "position": 70,
    "id": "card_070",
    "image": "battle_1fad518b-b3c0-496f-b7de-d09ee43c357e_framed.png",
    "folder": "battle-cards",
    "pack": "Pack2"
  },
  {
    "position": 71,
    "id": "card_071",
    "image": "battle_277161b6-6e85-476e-a608-5fb158966d3d_framed.png",
    "folder": "battle-cards",
    "pack": "Pack2"
  },
  {
    "position": 72,
    "id": "card_072",
    "image": "battle_2a252525-59e0-4cd8-b179-13b367a0507e_framed.png",
    "folder": "battle-cards",
    "pack": "Pack2"
  },
  {
    "position": 73,
    "id": "card_073",
    "image": "battle_31019309-4a16-480e-a99b-3b548742b3d5_framed.png",
    "folder": "battle-cards",
    "pack": "Pack2"
  },
  {
    "position": 74,
    "id": "card_074",
    "image": "battle_33a0e8a7-5260-4ea9-bb79-a914f2b641d9_framed.png",
    "folder": "battle-cards",
    "pack": "Pack2"
  },
  {
    "position": 75,
    "id": "card_075",
    "image": "battle_370aa14f-4eed-456a-9429-e32d662e90b9_framed.png",
    "folder": "battle-cards",
    "pack": "Pack2"
  },
  {
    "position": 76,
    "id": "card_076",
    "image": "battle_37e600f0-6781-4678-b146-7cdfb6e88467_framed.png",
    "folder": "battle-cards",
    "pack": "Pack2"
  },
  {
    "position": 77,
    "id": "card_077",
    "image": "battle_3973ea41-b471-448b-a51c-f1e1173fa950_framed.png",
    "folder": "battle-cards",
    "pack": "Pack2"
  },
  {
    "position": 78,
    "id": "card_078",
    "image": "battle_3a4d92e3-f6fd-4498-a30b-5696a2c7fdc7_framed.png",
    "folder": "battle-cards",
    "pack": "Pack2"
  },
  {
    "position": 79,
    "id": "card_079",
    "image": "battle_3be4d89f-689c-49e3-b651-6511a0e97fa9_framed.png",
    "folder": "battle-cards",
    "pack": "Pack2"
  },
  {
    "position": 80,
    "id": "card_080",
    "image": "battle_3e8be21b-b12f-4605-8207-3d4b01f86d31_framed.png",
    "folder": "battle-cards",
    "pack": "Pack2"
  },
  {
    "position": 81,
    "id": "card_081",
    "image": "battle_400bb61a-f4f7-4d08-a670-a11e2a779cac_framed.png",
    "folder": "battle-cards",
    "pack": "Pack2"
  },
  {
    "position": 82,
    "id": "card_082",
    "image": "battle_41bb3d1b-1617-496c-9248-c02829448272_framed.png",
    "folder": "battle-cards",
    "pack": "Pack2"
  },
  {
    "position": 83,
    "id": "card_083",
    "image": "battle_4316609d-46de-4221-a04e-ade29c40dd76_framed.png",
    "folder": "battle-cards",
    "pack": "Pack2"
  },
  {
    "position": 84,
    "id": "card_084",
    "image": "battle_431e5e6d-a02e-46e3-9754-7da6d5eb1d65_framed.png",
    "folder": "battle-cards",
    "pack": "Pack2"
  },
  {
    "position": 85,
    "id": "card_085",
    "image": "battle_475c50b3-7870-4ae2-89a1-00a29d9d5737_framed.png",
    "folder": "battle-cards",
    "pack": "Pack2"
  },
  {
    "position": 86,
    "id": "card_086",
    "image": "battle_4bc70fb8-fa10-4175-a25f-7731a9135272_framed.png",
    "folder": "battle-cards",
    "pack": "Pack2"
  },
  {
    "position": 87,
    "id": "card_087",
    "image": "battle_4f75d8bc-9038-4c19-8a83-74183e671315_framed.png",
    "folder": "battle-cards",
    "pack": "Pack2"
  },
  {
    "position": 88,
    "id": "card_088",
    "image": "battle_574655e1-dbb7-4213-af52-96f80ba70a12_framed.png",
    "folder": "battle-cards",
    "pack": "Pack2"
  },
  {
    "position": 89,
    "id": "card_089",
    "image": "battle_57b006be-e6b7-457b-89e3-c28d4f9d669d_framed.png",
    "folder": "battle-cards",
    "pack": "Pack2"
  },
  {
    "position": 90,
    "id": "card_090",
    "image": "battle_59999d9f-5ea1-4935-961c-2e0fe8b1f8c1_framed.png",
    "folder": "battle-cards",
    "pack": "Pack2"
  },
  {
    "position": 91,
    "id": "card_091",
    "image": "battle_603b447c-62ad-42f5-88c7-983c4975f41e_framed.png",
    "folder": "battle-cards",
    "pack": "Pack2"
  },
  {
    "position": 92,
    "id": "card_092",
    "image": "battle_6251a85e-d747-4b22-b59d-1d4279640a67_framed.png",
    "folder": "battle-cards",
    "pack": "Pack2"
  },
  {
    "position": 93,
    "id": "card_093",
    "image": "battle_62a86f66-b74b-41c4-b619-435a29aa2627_framed.png",
    "folder": "battle-cards",
    "pack": "Pack2"
  },
  {
    "position": 94,
    "id": "card_094",
    "image": "battle_64af3870-e173-4fb4-82d3-91f1efef5460_framed.png",
    "folder": "battle-cards",
    "pack": "Pack2"
  },
  {
    "position": 95,
    "id": "card_095",
    "image": "battle_66066e72-dad6-498b-96c3-26198a3c55cc_framed.png",
    "folder": "battle-cards",
    "pack": "Pack2"
  },
  {
    "position": 96,
    "id": "card_096",
    "image": "battle_66a92ed7-5f33-455b-909d-d0da4aa0674f_framed.png",
    "folder": "battle-cards",
    "pack": "Pack2"
  },
  {
    "position": 97,
    "id": "card_097",
    "image": "battle_6bb4f692-fe1f-41a4-a842-65f70354323e2_framed.png",
    "folder": "battle-cards",
    "pack": "Pack2"
  },
  {
    "position": 98,
    "id": "card_098",
    "image": "battle_6ce45a7e-f285-4726-8165-170a8373c8b9_framed.png",
    "folder": "battle-cards",
    "pack": "Pack2"
  },
  {
    "position": 99,
    "id": "card_099",
    "image": "battle_74577e72-4e9f-4c5f-9881-fe79838c2934_framed.png",
    "folder": "battle-cards",
    "pack": "Pack2"
  },
  {
    "position": 100,
    "id": "card_100",
    "image": "battle_75347275-e756-4607-b7bd-d2385f18321a_framed.png",
    "folder": "battle-cards",
    "pack": "Pack2"
  },
  {
    "position": 101,
    "id": "card_101",
    "image": "battle_76109c64-2c26-4956-8f29-33f8894cf2ee_framed.png",
    "folder": "battle-cards",
    "pack": "Pack2"
  },
  {
    "position": 102,
    "id": "card_102",
    "image": "battle_766fbbc4-776d-416a-a8c5-93c9f839b25e_framed.png",
    "folder": "battle-cards",
    "pack": "Pack2"
  },
  {
    "position": 103,
    "id": "card_103",
    "image": "battle_7706cdce-74b9-4278-be73-5928cab87111_framed.png",
    "folder": "battle-cards",
    "pack": "Pack2"
  },
  {
    "position": 104,
    "id": "card_104",
    "image": "battle_7864f634-1942-4102-88e0-0447e71f1d0a_framed.png",
    "folder": "battle-cards",
    "pack": "Pack2"
  },
  {
    "position": 105,
    "id": "card_105",
    "image": "battle_7a49b852-dd1e-4011-836a-a2e28d3c4239_framed.png",
    "folder": "battle-cards",
    "pack": "Pack2"
  },
  {
    "position": 106,
    "id": "card_106",
    "image": "battle_7d9c3905-d4e4-42f5-b25d-4d7d54f964a3_framed.png",
    "folder": "battle-cards",
    "pack": "Pack2"
  },
  {
    "position": 107,
    "id": "card_107",
    "image": "battle_7eb759ed-79f7-4e1d-9cd2-2c1b4ec23c40_framed.png",
    "folder": "battle-cards",
    "pack": "Pack2"
  },
  {
    "position": 108,
    "id": "card_108",
    "image": "battle_81976493-a130-48aa-a2d4-55e597c85b34_framed.png",
    "folder": "battle-cards",
    "pack": "Pack2"
  },
  {
    "position": 109,
    "id": "card_109",
    "image": "battle_879de3df-785c-466c-940c-d317e83fb0b3_framed.png",
    "folder": "battle-cards",
    "pack": "Pack2"
  },
  {
    "position": 110,
    "id": "card_110",
    "image": "battle_89626c03-c955-46d4-b232-6e6cb3126320_framed.png",
    "folder": "battle-cards",
    "pack": "Pack2"
  },
  {
    "position": 111,
    "id": "card_111",
    "image": "battle_89fe0c7b-d318-471e-97f5-5e56f5e2f499_framed.png",
    "folder": "battle-cards",
    "pack": "Pack2"
  },
  {
    "position": 112,
    "id": "card_112",
    "image": "battle_8c91f509-51f1-44a6-85ad-e1217c347937_framed.png",
    "folder": "battle-cards",
    "pack": "Pack2"
  },
  {
    "position": 113,
    "id": "card_113",
    "image": "battle_960e3020-3128-4c9e-a2c0-a27ae5bfb8c5_framed.png",
    "folder": "battle-cards",
    "pack": "Pack2"
  },
  {
    "position": 114,
    "id": "card_114",
    "image": "battle_9b1284b8-a560-4ef1-a7aa-a0b7ca8588ff_framed.png",
    "folder": "battle-cards",
    "pack": "Pack2"
  },
  {
    "position": 115,
    "id": "card_115",
    "image": "battle_a101441f-a649-4b0c-bebb-1b78e49fbaef_framed.png",
    "folder": "battle-cards",
    "pack": "Pack2"
  },
  {
    "position": 116,
    "id": "card_116",
    "image": "battle_a5a936ce-dc0f-428d-a23d-9a162ab43f94_framed.png",
    "folder": "battle-cards",
    "pack": "Pack2"
  },
  {
    "position": 117,
    "id": "card_117",
    "image": "battle_a8f9d0b2-2cd0-43ca-a5d2-747e40d9ed73_framed.png",
    "folder": "battle-cards",
    "pack": "Pack2"
  },
  {
    "position": 118,
    "id": "card_118",
    "image": "battle_b0871204-d259-4fa3-b34f-cc0ecbdda30a_framed.png",
    "folder": "battle-cards",
    "pack": "Pack2"
  },
  {
    "position": 119,
    "id": "card_119",
    "image": "battle_b2cd2751-2e57-440e-9a0e-78f5e5df5553_framed.png",
    "folder": "battle-cards",
    "pack": "Pack2"
  },
  {
    "position": 120,
    "id": "card_120",
    "image": "battle_b56262cc-3115-4fc5-ac68-aed22cf661f6_framed.png",
    "folder": "battle-cards",
    "pack": "Pack2"
  },
  {
    "position": 121,
    "id": "card_121",
    "image": "battle_b6f57e19-ed6e-4609-8787-25d2fd16dddb_framed.png",
    "folder": "battle-cards",
    "pack": "Pack2"
  },
  {
    "position": 122,
    "id": "card_122",
    "image": "battle_b8e79fea-0fe5-4e2d-a817-87f477d7439f_framed.png",
    "folder": "battle-cards",
    "pack": "Pack2"
  },
  {
    "position": 123,
    "id": "card_123",
    "image": "battle_bcf59555-1c3d-461a-84b4-87c2e82f54bc_framed.png",
    "folder": "battle-cards",
    "pack": "Pack2"
  },
  {
    "position": 124,
    "id": "card_124",
    "image": "battle_bd6c51e8-a3eb-4066-b907-1f7b256d1c04_framed.png",
    "folder": "battle-cards",
    "pack": "Pack2"
  },
  {
    "position": 125,
    "id": "card_125",
    "image": "battle_c081d98a-0388-4a85-8dba-4111ad4269b0_framed.png",
    "folder": "battle-cards",
    "pack": "Pack2"
  },
  {
    "position": 126,
    "id": "card_126",
    "image": "battle_c166cbbe-f011-4061-ba5f-1a62e113bbcf_framed.png",
    "folder": "battle-cards",
    "pack": "Pack2"
  },
  {
    "position": 127,
    "id": "card_127",
    "image": "battle_c231b47c-51c0-4365-8b28-8e773d16a270_framed.png",
    "folder": "battle-cards",
    "pack": "Pack2"
  },
  {
    "position": 128,
    "id": "card_128",
    "image": "battle_c4b8fb48-6659-4af6-a9b1-5909520c4a41_framed.png",
    "folder": "battle-cards",
    "pack": "Pack2"
  },
  {
    "position": 129,
    "id": "card_129",
    "image": "battle_c610f9b9-5f3e-49b0-9e35-8c2aeb7890be_framed.png",
    "folder": "battle-cards",
    "pack": "Pack2"
  },
  {
    "position": 130,
    "id": "card_130",
    "image": "battle_c875be84-c00a-49eb-b6aa-624cd3400b24_framed.png",
    "folder": "battle-cards",
    "pack": "Pack2"
  },
  {
    "position": 131,
    "id": "card_131",
    "image": "battle_cb30bee1-3ece-4573-b837-118bd1608965_framed.png",
    "folder": "battle-cards",
    "pack": "Pack2"
  },
  {
    "position": 132,
    "id": "card_132",
    "image": "battle_cc625161-ea24-41cd-8715-b176da86ed2d_framed.png",
    "folder": "battle-cards",
    "pack": "Pack2"
  },
  {
    "position": 133,
    "id": "card_133",
    "image": "battle_cc6a4d83-eb98-4f0e-8e12-0748550e8e28_framed.png",
    "folder": "battle-cards",
    "pack": "Pack2"
  },
  {
    "position": 134,
    "id": "card_134",
    "image": "battle_ce21a0e2-9127-41b1-a31e-d833f1574825_framed.png",
    "folder": "battle-cards",
    "pack": "Pack2"
  },
  {
    "position": 135,
    "id": "card_135",
    "image": "battle_ce4f13cd-3c04-48ce-b4f1-6b367bad8639_framed.png",
    "folder": "battle-cards",
    "pack": "Pack2"
  },
  {
    "position": 136,
    "id": "card_136",
    "image": "battle_cfe6617b-5622-438e-94c4-3996584afa78_framed.png",
    "folder": "battle-cards",
    "pack": "Pack2"
  },
  {
    "position": 137,
    "id": "card_137",
    "image": "battle_d02c2ffc-7343-4cfd-8d99-87de9c28dbba_framed.png",
    "folder": "battle-cards",
    "pack": "Pack2"
  },
  {
    "position": 138,
    "id": "card_138",
    "image": "battle_d6815c3d-c50f-48a3-a1d4-64d0a8735595_framed.png",
    "folder": "battle-cards",
    "pack": "Pack2"
  },
  {
    "position": 139,
    "id": "card_139",
    "image": "battle_dac1efea-6141-4e53-981f-e8230f83323b_framed.png",
    "folder": "battle-cards",
    "pack": "Pack2"
  },
  {
    "position": 140,
    "id": "card_140",
    "image": "battle_dc95835a-d890-4446-aac9-c93d3e8f1559_framed.png",
    "folder": "battle-cards",
    "pack": "Pack2"
  },
  {
    "position": 141,
    "id": "card_141",
    "image": "battle_e3a80c3e-1643-4ecc-b15d-efc7ace4fe6f_framed.png",
    "folder": "battle-cards",
    "pack": "Pack2"
  },
  {
    "position": 142,
    "id": "card_142",
    "image": "battle_e7aa99ae-a5ef-4bd1-9f1a-6fda3b182219_framed.png",
    "folder": "battle-cards",
    "pack": "Pack2"
  },
  {
    "position": 143,
    "id": "card_143",
    "image": "battle_e8973dcd-7f30-4d7f-8947-7539468f03ec_framed.png",
    "folder": "battle-cards",
    "pack": "Pack2"
  },
  {
    "position": 144,
    "id": "card_144",
    "image": "battle_eb29eaaa-d70b-4fec-aca2-3d48ea2a4f57_framed.png",
    "folder": "battle-cards",
    "pack": "Pack2"
  },
  {
    "position": 145,
    "id": "card_145",
    "image": "battle_f5ae55c0-2b42-4e9f-b3e9-9aaed49679fb_framed.png",
    "folder": "battle-cards",
    "pack": "Pack2"
  },
  {
    "position": 146,
    "id": "card_146",
    "image": "battle_fb56de68-6bb2-4165-ace2-54521009ef52_framed.png",
    "folder": "battle-cards",
    "pack": "Pack2"
  },
  {
    "position": 147,
    "id": "card_147",
    "image": "battle_fe0950d3-e5fc-447c-b5c0-5d7ea3c695f9_framed.png",
    "folder": "battle-cards",
    "pack": "Pack2"
  },
  {
    "position": 148,
    "id": "card_148",
    "image": "battle_ff7ae875-3573-40a9-9be8-0547f6e667c4_framed.png",
    "folder": "battle-cards",
    "pack": "Pack2"
  },
  {
    "position": 149,
    "id": "card_149",
    "image": "battle_ff9de8e0-e0ce-4133-b661-87a9cfc7523e_framed.png",
    "folder": "battle-cards",
    "pack": "Pack2"
  },
  {
    "position": 150,
    "id": "card_150",
    "image": "battle_ffcc41e9-6fd7-4753-a98b-d45cae15a2af_framed.png",
    "folder": "battle-cards",
    "pack": "Pack2"
  },
  {
    "position": 151,
    "id": "card_151",
    "image": "build_7.png",
    "folder": "build-cards",
    "pack": "Pack3"
  },
  {
    "position": 152,
    "id": "card_152",
    "image": "build_8.png",
    "folder": "build-cards",
    "pack": "Pack3"
  },
  {
    "position": 153,
    "id": "card_153",
    "image": "build_9.png",
    "folder": "build-cards",
    "pack": "Pack3"
  },
  {
    "position": 154,
    "id": "card_154",
    "image": "build_10.png",
    "folder": "build-cards",
    "pack": "Pack3"
  },
  {
    "position": 155,
    "id": "card_155",
    "image": "build_11.png",
    "folder": "build-cards",
    "pack": "Pack3"
  },
  {
    "position": 156,
    "id": "card_156",
    "image": "build_12.png",
    "folder": "build-cards",
    "pack": "Pack3"
  },
  {
    "position": 157,
    "id": "card_157",
    "image": "build_13.png",
    "folder": "build-cards",
    "pack": "Pack3"
  },
  {
    "position": 158,
    "id": "card_158",
    "image": "build_14.png",
    "folder": "build-cards",
    "pack": "Pack3"
  },
  {
    "position": 159,
    "id": "card_159",
    "image": "build_15.png",
    "folder": "build-cards",
    "pack": "Pack3"
  },
  {
    "position": 160,
    "id": "card_160",
    "image": "build_16.png",
    "folder": "build-cards",
    "pack": "Pack3"
  },
  {
    "position": 161,
    "id": "card_161",
    "image": "build_17.png",
    "folder": "build-cards",
    "pack": "Pack3"
  },
  {
    "position": 162,
    "id": "card_162",
    "image": "build_18.png",
    "folder": "build-cards",
    "pack": "Pack3"
  },
  {
    "position": 163,
    "id": "card_163",
    "image": "build_19.png",
    "folder": "build-cards",
    "pack": "Pack3"
  },
  {
    "position": 164,
    "id": "card_164",
    "image": "build_20.png",
    "folder": "build-cards",
    "pack": "Pack3"
  },
  {
    "position": 165,
    "id": "card_165",
    "image": "build_21.png",
    "folder": "build-cards",
    "pack": "Pack3"
  },
  {
    "position": 166,
    "id": "card_166",
    "image": "build_22.png",
    "folder": "build-cards",
    "pack": "Pack3"
  },
  {
    "position": 167,
    "id": "card_167",
    "image": "build_23.png",
    "folder": "build-cards",
    "pack": "Pack3"
  },
  {
    "position": 168,
    "id": "card_168",
    "image": "build_24.png",
    "folder": "build-cards",
    "pack": "Pack3"
  },
  {
    "position": 169,
    "id": "card_169",
    "image": "build_25.png",
    "folder": "build-cards",
    "pack": "Pack3"
  },
  {
    "position": 170,
    "id": "card_170",
    "image": "build_26.png",
    "folder": "build-cards",
    "pack": "Pack3"
  },
  {
    "position": 171,
    "id": "card_171",
    "image": "build_27.png",
    "folder": "build-cards",
    "pack": "Pack3"
  },
  {
    "position": 172,
    "id": "card_172",
    "image": "build_28.png",
    "folder": "build-cards",
    "pack": "Pack3"
  },
  {
    "position": 173,
    "id": "card_173",
    "image": "build_29.png",
    "folder": "build-cards",
    "pack": "Pack3"
  },
  {
    "position": 174,
    "id": "card_174",
    "image": "build_30.png",
    "folder": "build-cards",
    "pack": "Pack3"
  },
  {
    "position": 175,
    "id": "card_175",
    "image": "build_31.png",
    "folder": "build-cards",
    "pack": "Pack3"
  },
  {
    "position": 176,
    "id": "card_176",
    "image": "build_32.png",
    "folder": "build-cards",
    "pack": "Pack3"
  },
  {
    "position": 177,
    "id": "card_177",
    "image": "build_33.png",
    "folder": "build-cards",
    "pack": "Pack3"
  },
  {
    "position": 178,
    "id": "card_178",
    "image": "build_34.png",
    "folder": "build-cards",
    "pack": "Pack3"
  },
  {
    "position": 179,
    "id": "card_179",
    "image": "build_35.png",
    "folder": "build-cards",
    "pack": "Pack3"
  },
  {
    "position": 180,
    "id": "card_180",
    "image": "build_36.png",
    "folder": "build-cards",
    "pack": "Pack3"
  },
  {
    "position": 181,
    "id": "card_181",
    "image": "build_37.png",
    "folder": "build-cards",
    "pack": "Pack3"
  },
  {
    "position": 182,
    "id": "card_182",
    "image": "build_38.png",
    "folder": "build-cards",
    "pack": "Pack3"
  },
  {
    "position": 183,
    "id": "card_183",
    "image": "build_39.png",
    "folder": "build-cards",
    "pack": "Pack3"
  },
  {
    "position": 184,
    "id": "card_184",
    "image": "build_40.png",
    "folder": "build-cards",
    "pack": "Pack3"
  },
  {
    "position": 185,
    "id": "card_185",
    "image": "build_41.png",
    "folder": "build-cards",
    "pack": "Pack3"
  },
  {
    "position": 186,
    "id": "card_186",
    "image": "build_42.png",
    "folder": "build-cards",
    "pack": "Pack3"
  },
  {
    "position": 187,
    "id": "card_187",
    "image": "build_43.png",
    "folder": "build-cards",
    "pack": "Pack3"
  },
  {
    "position": 188,
    "id": "card_188",
    "image": "build_44.png",
    "folder": "build-cards",
    "pack": "Pack3"
  },
  {
    "position": 189,
    "id": "card_189",
    "image": "build_45.png",
    "folder": "build-cards",
    "pack": "Pack3"
  },
  {
    "position": 190,
    "id": "card_190",
    "image": "build_46.png",
    "folder": "build-cards",
    "pack": "Pack3"
  },
  {
    "position": 191,
    "id": "card_191",
    "image": "build_47.png",
    "folder": "build-cards",
    "pack": "Pack3"
  },
  {
    "position": 192,
    "id": "card_192",
    "image": "build_48.png",
    "folder": "build-cards",
    "pack": "Pack3"
  },
  {
    "position": 193,
    "id": "card_193",
    "image": "build_49.png",
    "folder": "build-cards",
    "pack": "Pack3"
  },
  {
    "position": 194,
    "id": "card_194",
    "image": "build_50.png",
    "folder": "build-cards",
    "pack": "Pack3"
  },
  {
    "position": 195,
    "id": "card_195",
    "image": "build_51.png",
    "folder": "build-cards",
    "pack": "Pack3"
  },
  {
    "position": 196,
    "id": "card_196",
    "image": "build_52.png",
    "folder": "build-cards",
    "pack": "Pack3"
  },
  {
    "position": 197,
    "id": "card_197",
    "image": "build_53.png",
    "folder": "build-cards",
    "pack": "Pack3"
  },
  {
    "position": 198,
    "id": "card_198",
    "image": "build_54.png",
    "folder": "build-cards",
    "pack": "Pack3"
  },
  {
    "position": 199,
    "id": "card_199",
    "image": "build_55.png",
    "folder": "build-cards",
    "pack": "Pack3"
  },
  {
    "position": 200,
    "id": "card_200",
    "image": "build_56.png",
    "folder": "build-cards",
    "pack": "Pack3"
  },
  {
    "position": 201,
    "id": "card_201",
    "image": "build_57.png",
    "folder": "build-cards",
    "pack": "Pack3"
  },
  {
    "position": 202,
    "id": "card_202",
    "image": "build_58.png",
    "folder": "build-cards",
    "pack": "Pack3"
  },
  {
    "position": 203,
    "id": "card_203",
    "image": "build_59.png",
    "folder": "build-cards",
    "pack": "Pack3"
  },
  {
    "position": 204,
    "id": "card_204",
    "image": "build_60.png",
    "folder": "build-cards",
    "pack": "Pack3"
  },
  {
    "position": 205,
    "id": "card_205",
    "image": "build_61.png",
    "folder": "build-cards",
    "pack": "Pack3"
  },
  {
    "position": 206,
    "id": "card_206",
    "image": "build_62.png",
    "folder": "build-cards",
    "pack": "Pack3"
  },
  {
    "position": 207,
    "id": "card_207",
    "image": "build_63.png",
    "folder": "build-cards",
    "pack": "Pack3"
  },
  {
    "position": 208,
    "id": "card_208",
    "image": "build_64.png",
    "folder": "build-cards",
    "pack": "Pack3"
  },
  {
    "position": 209,
    "id": "card_209",
    "image": "build_65.png",
    "folder": "build-cards",
    "pack": "Pack3"
  },
  {
    "position": 210,
    "id": "card_210",
    "image": "build_66.png",
    "folder": "build-cards",
    "pack": "Pack3"
  },
  {
    "position": 211,
    "id": "card_211",
    "image": "build_67.png",
    "folder": "build-cards",
    "pack": "Pack3"
  },
  {
    "position": 212,
    "id": "card_212",
    "image": "build_68.png",
    "folder": "build-cards",
    "pack": "Pack3"
  },
  {
    "position": 213,
    "id": "card_213",
    "image": "build_69.png",
    "folder": "build-cards",
    "pack": "Pack3"
  },
  {
    "position": 214,
    "id": "card_214",
    "image": "build_70.png",
    "folder": "build-cards",
    "pack": "Pack3"
  },
  {
    "position": 215,
    "id": "card_215",
    "image": "build_71.png",
    "folder": "build-cards",
    "pack": "Pack3"
  },
  {
    "position": 216,
    "id": "card_216",
    "image": "build_72.png",
    "folder": "build-cards",
    "pack": "Pack3"
  },
  {
    "position": 217,
    "id": "card_217",
    "image": "build_73.png",
    "folder": "build-cards",
    "pack": "Pack3"
  },
  {
    "position": 218,
    "id": "card_218",
    "image": "build_74.png",
    "folder": "build-cards",
    "pack": "Pack3"
  },
  {
    "position": 219,
    "id": "card_219",
    "image": "build_75.png",
    "folder": "build-cards",
    "pack": "Pack3"
  },
  {
    "position": 220,
    "id": "card_220",
    "image": "build_76.png",
    "folder": "build-cards",
    "pack": "Pack3"
  },
  {
    "position": 221,
    "id": "card_221",
    "image": "build_77.png",
    "folder": "build-cards",
    "pack": "Pack3"
  },
  {
    "position": 222,
    "id": "card_222",
    "image": "build_78.png",
    "folder": "build-cards",
    "pack": "Pack3"
  },
  {
    "position": 223,
    "id": "card_223",
    "image": "build_79.png",
    "folder": "build-cards",
    "pack": "Pack3"
  },
  {
    "position": 224,
    "id": "card_224",
    "image": "build_80.png",
    "folder": "build-cards",
    "pack": "Pack3"
  },
  {
    "position": 225,
    "id": "card_225",
    "image": "build_81.png",
    "folder": "build-cards",
    "pack": "Pack3"
  },
  {
    "position": 226,
    "id": "card_226",
    "image": "build_82.png",
    "folder": "build-cards",
    "pack": "Pack3"
  },
  {
    "position": 227,
    "id": "card_227",
    "image": "build_83.png",
    "folder": "build-cards",
    "pack": "Pack3"
  },
  {
    "position": 228,
    "id": "card_228",
    "image": "build_84.png",
    "folder": "build-cards",
    "pack": "Pack3"
  },
  {
    "position": 229,
    "id": "card_229",
    "image": "build_85.png",
    "folder": "build-cards",
    "pack": "Pack3"
  },
  {
    "position": 230,
    "id": "card_230",
    "image": "build_86.png",
    "folder": "build-cards",
    "pack": "Pack3"
  },
  {
    "position": 231,
    "id": "card_231",
    "image": "build_87.png",
    "folder": "build-cards",
    "pack": "Pack3"
  },
  {
    "position": 232,
    "id": "card_232",
    "image": "build_88.png",
    "folder": "build-cards",
    "pack": "Pack3"
  },
  {
    "position": 233,
    "id": "card_233",
    "image": "build_89.png",
    "folder": "build-cards",
    "pack": "Pack3"
  },
  {
    "position": 234,
    "id": "card_234",
    "image": "build_90.png",
    "folder": "build-cards",
    "pack": "Pack3"
  },
  {
    "position": 235,
    "id": "card_235",
    "image": "build_91.png",
    "folder": "build-cards",
    "pack": "Pack3"
  },
  {
    "position": 236,
    "id": "card_236",
    "image": "build_92.png",
    "folder": "build-cards",
    "pack": "Pack3"
  },
  {
    "position": 237,
    "id": "card_237",
    "image": "build_93.png",
    "folder": "build-cards",
    "pack": "Pack3"
  },
  {
    "position": 238,
    "id": "card_238",
    "image": "build_94.png",
    "folder": "build-cards",
    "pack": "Pack3"
  },
  {
    "position": 239,
    "id": "card_239",
    "image": "build_95.png",
    "folder": "build-cards",
    "pack": "Pack3"
  },
  {
    "position": 240,
    "id": "card_240",
    "image": "build_96.png",
    "folder": "build-cards",
    "pack": "Pack3"
  },
  {
    "position": 241,
    "id": "card_241",
    "image": "build_97.png",
    "folder": "build-cards",
    "pack": "Pack4"
  },
  {
    "position": 242,
    "id": "card_242",
    "image": "build_98.png",
    "folder": "build-cards",
    "pack": "Pack4"
  },
  {
    "position": 243,
    "id": "card_243",
    "image": "build_99.png",
    "folder": "build-cards",
    "pack": "Pack4"
  },
  {
    "position": 244,
    "id": "card_244",
    "image": "build_100.png",
    "folder": "build-cards",
    "pack": "Pack4"
  },
  {
    "position": 245,
    "id": "card_245",
    "image": "build_101.png",
    "folder": "build-cards",
    "pack": "Pack4"
  },
  {
    "position": 246,
    "id": "card_246",
    "image": "build_102.png",
    "folder": "build-cards",
    "pack": "Pack4"
  },
  {
    "position": 247,
    "id": "card_247",
    "image": "build_103.png",
    "folder": "build-cards",
    "pack": "Pack4"
  },
  {
    "position": 248,
    "id": "card_248",
    "image": "build_104.png",
    "folder": "build-cards",
    "pack": "Pack4"
  },
  {
    "position": 249,
    "id": "card_249",
    "image": "build_105.png",
    "folder": "build-cards",
    "pack": "Pack4"
  },
  {
    "position": 250,
    "id": "card_250",
    "image": "build_106.png",
    "folder": "build-cards",
    "pack": "Pack4"
  },
  {
    "position": 251,
    "id": "card_251",
    "image": "build_107.png",
    "folder": "build-cards",
    "pack": "Pack4"
  },
  {
    "position": 252,
    "id": "card_252",
    "image": "build_108.png",
    "folder": "build-cards",
    "pack": "Pack4"
  },
  {
    "position": 253,
    "id": "card_253",
    "image": "build_109.png",
    "folder": "build-cards",
    "pack": "Pack4"
  },
  {
    "position": 254,
    "id": "card_254",
    "image": "build_110.png",
    "folder": "build-cards",
    "pack": "Pack4"
  },
  {
    "position": 255,
    "id": "card_255",
    "image": "build_111.png",
    "folder": "build-cards",
    "pack": "Pack4"
  },
  {
    "position": 256,
    "id": "card_256",
    "image": "build_112.png",
    "folder": "build-cards",
    "pack": "Pack4"
  },
  {
    "position": 257,
    "id": "card_257",
    "image": "build_113.png",
    "folder": "build-cards",
    "pack": "Pack4"
  },
  {
    "position": 258,
    "id": "card_258",
    "image": "build_114.png",
    "folder": "build-cards",
    "pack": "Pack4"
  },
  {
    "position": 259,
    "id": "card_259",
    "image": "build_115.png",
    "folder": "build-cards",
    "pack": "Pack4"
  },
  {
    "position": 260,
    "id": "card_260",
    "image": "build_116.png",
    "folder": "build-cards",
    "pack": "Pack4"
  },
  {
    "position": 261,
    "id": "card_261",
    "image": "build_117.png",
    "folder": "build-cards",
    "pack": "Pack4"
  },
  {
    "position": 262,
    "id": "card_262",
    "image": "build_118.png",
    "folder": "build-cards",
    "pack": "Pack4"
  },
  {
    "position": 263,
    "id": "card_263",
    "image": "build_119.png",
    "folder": "build-cards",
    "pack": "Pack4"
  },
  {
    "position": 264,
    "id": "card_264",
    "image": "build_120.png",
    "folder": "build-cards",
    "pack": "Pack4"
  },
  {
    "position": 265,
    "id": "card_265",
    "image": "build_121.png",
    "folder": "build-cards",
    "pack": "Pack4"
  },
  {
    "position": 266,
    "id": "card_266",
    "image": "build_122.png",
    "folder": "build-cards",
    "pack": "Pack4"
  },
  {
    "position": 267,
    "id": "card_267",
    "image": "build_123.png",
    "folder": "build-cards",
    "pack": "Pack4"
  },
  {
    "position": 268,
    "id": "card_268",
    "image": "build_124.png",
    "folder": "build-cards",
    "pack": "Pack4"
  },
  {
    "position": 269,
    "id": "card_269",
    "image": "build_125.png",
    "folder": "build-cards",
    "pack": "Pack4"
  },
  {
    "position": 270,
    "id": "card_270",
    "image": "build_126.png",
    "folder": "build-cards",
    "pack": "Pack4"
  },
  {
    "position": 271,
    "id": "card_271",
    "image": "build_127.png",
    "folder": "build-cards",
    "pack": "Pack4"
  },
  {
    "position": 272,
    "id": "card_272",
    "image": "build_128.png",
    "folder": "build-cards",
    "pack": "Pack4"
  },
  {
    "position": 273,
    "id": "card_273",
    "image": "build_129.png",
    "folder": "build-cards",
    "pack": "Pack4"
  },
  {
    "position": 274,
    "id": "card_274",
    "image": "build_130.png",
    "folder": "build-cards",
    "pack": "Pack4"
  },
  {
    "position": 275,
    "id": "card_275",
    "image": "build_131.png",
    "folder": "build-cards",
    "pack": "Pack4"
  },
  {
    "position": 276,
    "id": "card_276",
    "image": "build_132.png",
    "folder": "build-cards",
    "pack": "Pack4"
  },
  {
    "position": 277,
    "id": "card_277",
    "image": "build_133.png",
    "folder": "build-cards",
    "pack": "Pack4"
  },
  {
    "position": 278,
    "id": "card_278",
    "image": "build_134.png",
    "folder": "build-cards",
    "pack": "Pack4"
  },
  {
    "position": 279,
    "id": "card_279",
    "image": "build_135.png",
    "folder": "build-cards",
    "pack": "Pack4"
  },
  {
    "position": 280,
    "id": "card_280",
    "image": "build_136.png",
    "folder": "build-cards",
    "pack": "Pack4"
  },
  {
    "position": 281,
    "id": "card_281",
    "image": "build_137.png",
    "folder": "build-cards",
    "pack": "Pack4"
  },
  {
    "position": 282,
    "id": "card_282",
    "image": "build_138.png",
    "folder": "build-cards",
    "pack": "Pack4"
  },
  {
    "position": 283,
    "id": "card_283",
    "image": "build_139.png",
    "folder": "build-cards",
    "pack": "Pack4"
  },
  {
    "position": 284,
    "id": "card_284",
    "image": "build_140.png",
    "folder": "build-cards",
    "pack": "Pack4"
  },
  {
    "position": 285,
    "id": "card_285",
    "image": "build_141.png",
    "folder": "build-cards",
    "pack": "Pack4"
  },
  {
    "position": 286,
    "id": "card_286",
    "image": "build_142.png",
    "folder": "build-cards",
    "pack": "Pack4"
  },
  {
    "position": 287,
    "id": "card_287",
    "image": "build_143.png",
    "folder": "build-cards",
    "pack": "Pack4"
  },
  {
    "position": 288,
    "id": "card_288",
    "image": "build_144.png",
    "folder": "build-cards",
    "pack": "Pack4"
  },
  {
    "position": 289,
    "id": "card_289",
    "image": "build_145.png",
    "folder": "build-cards",
    "pack": "Pack4"
  },
  {
    "position": 290,
    "id": "card_290",
    "image": "build_146.png",
    "folder": "build-cards",
    "pack": "Pack4"
  },
  {
    "position": 291,
    "id": "card_291",
    "image": "build_147.png",
    "folder": "build-cards",
    "pack": "Pack4"
  },
  {
    "position": 292,
    "id": "card_292",
    "image": "build_148.png",
    "folder": "build-cards",
    "pack": "Pack4"
  },
  {
    "position": 293,
    "id": "card_293",
    "image": "build_149.png",
    "folder": "build-cards",
    "pack": "Pack4"
  },
  {
    "position": 294,
    "id": "card_294",
    "image": "build_150.png",
    "folder": "build-cards",
    "pack": "Pack4"
  },
  {
    "position": 295,
    "id": "card_295",
    "image": "build_151.png",
    "folder": "build-cards",
    "pack": "Pack4"
  },
  {
    "position": 296,
    "id": "card_296",
    "image": "build_152.png",
    "folder": "build-cards",
    "pack": "Pack4"
  },
  {
    "position": 297,
    "id": "card_297",
    "image": "build_153.png",
    "folder": "build-cards",
    "pack": "Pack4"
  },
  {
    "position": 298,
    "id": "card_298",
    "image": "build_154.png",
    "folder": "build-cards",
    "pack": "Pack4"
  },
  {
    "position": 299,
    "id": "card_299",
    "image": "build_155.png",
    "folder": "build-cards",
    "pack": "Pack4"
  },
  {
    "position": 300,
    "id": "card_300",
    "image": "build_156.png",
    "folder": "build-cards",
    "pack": "Pack4"
  },
  {
    "position": 301,
    "id": "card_301",
    "image": "earth1.png",
    "folder": "move-cards",
    "pack": "Pack4"
  },
  {
    "position": 302,
    "id": "card_302",
    "image": "earth14.png",
    "folder": "move-cards",
    "pack": "Pack4"
  },
  {
    "position": 303,
    "id": "card_303",
    "image": "earth15.png",
    "folder": "move-cards",
    "pack": "Pack4"
  },
  {
    "position": 304,
    "id": "card_304",
    "image": "earth17.png",
    "folder": "move-cards",
    "pack": "Pack4"
  },
  {
    "position": 305,
    "id": "card_305",
    "image": "earth21.png",
    "folder": "move-cards",
    "pack": "Pack4"
  },
  {
    "position": 306,
    "id": "card_306",
    "image": "earth23.png",
    "folder": "move-cards",
    "pack": "Pack4"
  },
  {
    "position": 307,
    "id": "card_307",
    "image": "earth28.png",
    "folder": "move-cards",
    "pack": "Pack4"
  },
  {
    "position": 308,
    "id": "card_308",
    "image": "earth29.png",
    "folder": "move-cards",
    "pack": "Pack4"
  },
  {
    "position": 309,
    "id": "card_309",
    "image": "earth3.png",
    "folder": "move-cards",
    "pack": "Pack4"
  },
  {
    "position": 310,
    "id": "card_310",
    "image": "earth31.png",
    "folder": "move-cards",
    "pack": "Pack4"
  },
  {
    "position": 311,
    "id": "card_311",
    "image": "earth32.png",
    "folder": "move-cards",
    "pack": "Pack4"
  },
  {
    "position": 312,
    "id": "card_312",
    "image": "earth34.png",
    "folder": "move-cards",
    "pack": "Pack4"
  },
  {
    "position": 313,
    "id": "card_313",
    "image": "earth36.png",
    "folder": "move-cards",
    "pack": "Pack4"
  },
  {
    "position": 314,
    "id": "card_314",
    "image": "earth37.png",
    "folder": "move-cards",
    "pack": "Pack4"
  },
  {
    "position": 315,
    "id": "card_315",
    "image": "earth40.png",
    "folder": "move-cards",
    "pack": "Pack4"
  },
  {
    "position": 316,
    "id": "card_316",
    "image": "earth41.png",
    "folder": "move-cards",
    "pack": "Pack4"
  },
  {
    "position": 317,
    "id": "card_317",
    "image": "earth42.png",
    "folder": "move-cards",
    "pack": "Pack4"
  },
  {
    "position": 318,
    "id": "card_318",
    "image": "earth43.png",
    "folder": "move-cards",
    "pack": "Pack4"
  },
  {
    "position": 319,
    "id": "card_319",
    "image": "earth9.png",
    "folder": "move-cards",
    "pack": "Pack4"
  },
  {
    "position": 320,
    "id": "card_320",
    "image": "fire1.png",
    "folder": "move-cards",
    "pack": "Pack4"
  },
  {
    "position": 321,
    "id": "card_321",
    "image": "fire10.png",
    "folder": "move-cards",
    "pack": "Pack4"
  },
  {
    "position": 322,
    "id": "card_322",
    "image": "fire12.png",
    "folder": "move-cards",
    "pack": "Pack4"
  },
  {
    "position": 323,
    "id": "card_323",
    "image": "fire14.png",
    "folder": "move-cards",
    "pack": "Pack4"
  },
  {
    "position": 324,
    "id": "card_324",
    "image": "fire18.png",
    "folder": "move-cards",
    "pack": "Pack4"
  },
  {
    "position": 325,
    "id": "card_325",
    "image": "fire20.png",
    "folder": "move-cards",
    "pack": "Pack4"
  },
  {
    "position": 326,
    "id": "card_326",
    "image": "fire21.png",
    "folder": "move-cards",
    "pack": "Pack4"
  },
  {
    "position": 327,
    "id": "card_327",
    "image": "fire22.png",
    "folder": "move-cards",
    "pack": "Pack4"
  },
  {
    "position": 328,
    "id": "card_328",
    "image": "fire24.png",
    "folder": "move-cards",
    "pack": "Pack4"
  },
  {
    "position": 329,
    "id": "card_329",
    "image": "fire31.png",
    "folder": "move-cards",
    "pack": "Pack4"
  },
  {
    "position": 330,
    "id": "card_330",
    "image": "fire32.png",
    "folder": "move-cards",
    "pack": "Pack4"
  },
  {
    "position": 331,
    "id": "card_331",
    "image": "fire33.png",
    "folder": "move-cards",
    "pack": "Pack5"
  },
  {
    "position": 332,
    "id": "card_332",
    "image": "fire34.png",
    "folder": "move-cards",
    "pack": "Pack5"
  },
  {
    "position": 333,
    "id": "card_333",
    "image": "fire35.png",
    "folder": "move-cards",
    "pack": "Pack5"
  },
  {
    "position": 334,
    "id": "card_334",
    "image": "fire37.png",
    "folder": "move-cards",
    "pack": "Pack5"
  },
  {
    "position": 335,
    "id": "card_335",
    "image": "fire38.png",
    "folder": "move-cards",
    "pack": "Pack5"
  },
  {
    "position": 336,
    "id": "card_336",
    "image": "fire40.png",
    "folder": "move-cards",
    "pack": "Pack5"
  },
  {
    "position": 337,
    "id": "card_337",
    "image": "fire42.png",
    "folder": "move-cards",
    "pack": "Pack5"
  },
  {
    "position": 338,
    "id": "card_338",
    "image": "fire44.png",
    "folder": "move-cards",
    "pack": "Pack5"
  },
  {
    "position": 339,
    "id": "card_339",
    "image": "fire5.png",
    "folder": "move-cards",
    "pack": "Pack5"
  },
  {
    "position": 340,
    "id": "card_340",
    "image": "fire50.png",
    "folder": "move-cards",
    "pack": "Pack5"
  },
  {
    "position": 341,
    "id": "card_341",
    "image": "fire57.png",
    "folder": "move-cards",
    "pack": "Pack5"
  },
  {
    "position": 342,
    "id": "card_342",
    "image": "fire58.png",
    "folder": "move-cards",
    "pack": "Pack5"
  },
  {
    "position": 343,
    "id": "card_343",
    "image": "fire62.png",
    "folder": "move-cards",
    "pack": "Pack5"
  },
  {
    "position": 344,
    "id": "card_344",
    "image": "fire63.png",
    "folder": "move-cards",
    "pack": "Pack5"
  },
  {
    "position": 345,
    "id": "card_345",
    "image": "fire7.png",
    "folder": "move-cards",
    "pack": "Pack5"
  },
  {
    "position": 346,
    "id": "card_346",
    "image": "fire8.png",
    "folder": "move-cards",
    "pack": "Pack5"
  },
  {
    "position": 347,
    "id": "card_347",
    "image": "forest1.png",
    "folder": "move-cards",
    "pack": "Pack5"
  },
  {
    "position": 348,
    "id": "card_348",
    "image": "forest12.png",
    "folder": "move-cards",
    "pack": "Pack5"
  },
  {
    "position": 349,
    "id": "card_349",
    "image": "forest13.png",
    "folder": "move-cards",
    "pack": "Pack5"
  },
  {
    "position": 350,
    "id": "card_350",
    "image": "forest15.png",
    "folder": "move-cards",
    "pack": "Pack5"
  },
  {
    "position": 351,
    "id": "card_351",
    "image": "forest16.png",
    "folder": "move-cards",
    "pack": "Pack5"
  },
  {
    "position": 352,
    "id": "card_352",
    "image": "forest17.png",
    "folder": "move-cards",
    "pack": "Pack5"
  },
  {
    "position": 353,
    "id": "card_353",
    "image": "forest19.png",
    "folder": "move-cards",
    "pack": "Pack5"
  },
  {
    "position": 354,
    "id": "card_354",
    "image": "forest2.png",
    "folder": "move-cards",
    "pack": "Pack5"
  },
  {
    "position": 355,
    "id": "card_355",
    "image": "forest20.png",
    "folder": "move-cards",
    "pack": "Pack5"
  },
  {
    "position": 356,
    "id": "card_356",
    "image": "forest21.png",
    "folder": "move-cards",
    "pack": "Pack5"
  },
  {
    "position": 357,
    "id": "card_357",
    "image": "forest22.png",
    "folder": "move-cards",
    "pack": "Pack5"
  },
  {
    "position": 358,
    "id": "card_358",
    "image": "forest23.png",
    "folder": "move-cards",
    "pack": "Pack5"
  },
  {
    "position": 359,
    "id": "card_359",
    "image": "forest4.png",
    "folder": "move-cards",
    "pack": "Pack5"
  },
  {
    "position": 360,
    "id": "card_360",
    "image": "forest5.png",
    "folder": "move-cards",
    "pack": "Pack5"
  },
  {
    "position": 361,
    "id": "card_361",
    "image": "water10.png",
    "folder": "move-cards",
    "pack": "Pack5"
  },
  {
    "position": 362,
    "id": "card_362",
    "image": "water11.png",
    "folder": "move-cards",
    "pack": "Pack5"
  },
  {
    "position": 363,
    "id": "card_363",
    "image": "water13.png",
    "folder": "move-cards",
    "pack": "Pack5"
  },
  {
    "position": 364,
    "id": "card_364",
    "image": "water14.png",
    "folder": "move-cards",
    "pack": "Pack5"
  },
  {
    "position": 365,
    "id": "card_365",
    "image": "water16.png",
    "folder": "move-cards",
    "pack": "Pack5"
  },
  {
    "position": 366,
    "id": "card_366",
    "image": "water17.png",
    "folder": "move-cards",
    "pack": "Pack5"
  },
  {
    "position": 367,
    "id": "card_367",
    "image": "water18.png",
    "folder": "move-cards",
    "pack": "Pack5"
  },
  {
    "position": 368,
    "id": "card_368",
    "image": "water20.png",
    "folder": "move-cards",
    "pack": "Pack5"
  },
  {
    "position": 369,
    "id": "card_369",
    "image": "water7.png",
    "folder": "move-cards",
    "pack": "Pack5"
  },
  {
    "position": 370,
    "id": "card_370",
    "image": "water8.png",
    "folder": "move-cards",
    "pack": "Pack5"
  },
  {
    "position": 371,
    "id": "card_371",
    "image": "train_albert-einstein.png",
    "folder": "train-cards",
    "pack": "Pack5"
  },
  {
    "position": 372,
    "id": "card_372",
    "image": "train_alexander-the-great.png",
    "folder": "train-cards",
    "pack": "Pack5"
  },
  {
    "position": 373,
    "id": "card_373",
    "image": "train_amelia-earhart.png",
    "folder": "train-cards",
    "pack": "Pack5"
  },
  {
    "position": 374,
    "id": "card_374",
    "image": "train_American-Horse.png",
    "folder": "train-cards",
    "pack": "Pack5"
  },
  {
    "position": 375,
    "id": "card_375",
    "image": "train_attila-the-hun.png",
    "folder": "train-cards",
    "pack": "Pack5"
  },
  {
    "position": 376,
    "id": "card_376",
    "image": "train_Black-Hawk.png",
    "folder": "train-cards",
    "pack": "Pack5"
  },
  {
    "position": 377,
    "id": "card_377",
    "image": "train_Black-Kettle.png",
    "folder": "train-cards",
    "pack": "Pack5"
  },
  {
    "position": 378,
    "id": "card_378",
    "image": "train_blackbeard.png",
    "folder": "train-cards",
    "pack": "Pack5"
  },
  {
    "position": 379,
    "id": "card_379",
    "image": "train_Blue-Jacket.png",
    "folder": "train-cards",
    "pack": "Pack5"
  },
  {
    "position": 380,
    "id": "card_380",
    "image": "train_boudica.png",
    "folder": "train-cards",
    "pack": "Pack5"
  },
  {
    "position": 381,
    "id": "card_381",
    "image": "train_che-guevara.png",
    "folder": "train-cards",
    "pack": "Pack5"
  },
  {
    "position": 382,
    "id": "card_382",
    "image": "train_Chief-Joseph.png",
    "folder": "train-cards",
    "pack": "Pack5"
  },
  {
    "position": 383,
    "id": "card_383",
    "image": "train_christopher-columbus.png",
    "folder": "train-cards",
    "pack": "Pack5"
  },
  {
    "position": 384,
    "id": "card_384",
    "image": "train_cleopatra-vii.png",
    "folder": "train-cards",
    "pack": "Pack5"
  },
  {
    "position": 385,
    "id": "card_385",
    "image": "train_Cochise.png",
    "folder": "train-cards",
    "pack": "Pack5"
  },
  {
    "position": 386,
    "id": "card_386",
    "image": "train_Cornstalk.png",
    "folder": "train-cards",
    "pack": "Pack5"
  },
  {
    "position": 387,
    "id": "card_387",
    "image": "train_Crazy-Horse.png",
    "folder": "train-cards",
    "pack": "Pack5"
  },
  {
    "position": 388,
    "id": "card_388",
    "image": "train_date-masamune.png",
    "folder": "train-cards",
    "pack": "Pack5"
  },
  {
    "position": 389,
    "id": "card_389",
    "image": "train_Dull-Knife.png",
    "folder": "train-cards",
    "pack": "Pack5"
  },
  {
    "position": 390,
    "id": "card_390",
    "image": "train_edgar-allan-poe.png",
    "folder": "train-cards",
    "pack": "Pack5"
  },
  {
    "position": 391,
    "id": "card_391",
    "image": "train_emperor-meiji.png",
    "folder": "train-cards",
    "pack": "Pack5"
  },
  {
    "position": 392,
    "id": "card_392",
    "image": "train_ernest-shackleton.png",
    "folder": "train-cards",
    "pack": "Pack5"
  },
  {
    "position": 393,
    "id": "card_393",
    "image": "train_fuma-kotaro.png",
    "folder": "train-cards",
    "pack": "Pack5"
  },
  {
    "position": 394,
    "id": "card_394",
    "image": "train_galileo-galilei.png",
    "folder": "train-cards",
    "pack": "Pack5"
  },
  {
    "position": 395,
    "id": "card_395",
    "image": "train_Gall.png",
    "folder": "train-cards",
    "pack": "Pack5"
  },
  {
    "position": 396,
    "id": "card_396",
    "image": "train_geisha-master.png",
    "folder": "train-cards",
    "pack": "Pack5"
  },
  {
    "position": 397,
    "id": "card_397",
    "image": "train_Geronimo.png",
    "folder": "train-cards",
    "pack": "Pack5"
  },
  {
    "position": 398,
    "id": "card_398",
    "image": "train_hannibal-barca.png",
    "folder": "train-cards",
    "pack": "Pack5"
  },
  {
    "position": 399,
    "id": "card_399",
    "image": "train_hattori-hanzo.png",
    "folder": "train-cards",
    "pack": "Pack5"
  },
  {
    "position": 400,
    "id": "card_400",
    "image": "train_honda-tadakatsu.png",
    "folder": "train-cards",
    "pack": "Pack5"
  },
  {
    "position": 401,
    "id": "card_401",
    "image": "train_ikebana-master.png",
    "folder": "train-cards",
    "pack": "Pack5"
  },
  {
    "position": 402,
    "id": "card_402",
    "image": "train_isaac-newton.png",
    "folder": "train-cards",
    "pack": "Pack5"
  },
  {
    "position": 403,
    "id": "card_403",
    "image": "train_jiraiya.png",
    "folder": "train-cards",
    "pack": "Pack5"
  },
  {
    "position": 404,
    "id": "card_404",
    "image": "train_julius-caesar.png",
    "folder": "train-cards",
    "pack": "Pack5"
  },
  {
    "position": 405,
    "id": "card_405",
    "image": "train_kabuki-actor.png",
    "folder": "train-cards",
    "pack": "Pack5"
  },
  {
    "position": 406,
    "id": "card_406",
    "image": "train_Kamiakin.png",
    "folder": "train-cards",
    "pack": "Pack5"
  },
  {
    "position": 407,
    "id": "card_407",
    "image": "train_kendo-master.png",
    "folder": "train-cards",
    "pack": "Pack5"
  },
  {
    "position": 408,
    "id": "card_408",
    "image": "train_king-leonidas.png",
    "folder": "train-cards",
    "pack": "Pack5"
  },
  {
    "position": 409,
    "id": "card_409",
    "image": "train_King-Philip-Metacomet.png",
    "folder": "train-cards",
    "pack": "Pack5"
  },
  {
    "position": 410,
    "id": "card_410",
    "image": "train_kyudo-archer.png",
    "folder": "train-cards",
    "pack": "Pack5"
  },
  {
    "position": 411,
    "id": "card_411",
    "image": "train_Leschi.png",
    "folder": "train-cards",
    "pack": "Pack5"
  },
  {
    "position": 412,
    "id": "card_412",
    "image": "train_lewis-clark.png",
    "folder": "train-cards",
    "pack": "Pack5"
  },
  {
    "position": 413,
    "id": "card_413",
    "image": "train_Little-Turtle.png",
    "folder": "train-cards",
    "pack": "Pack5"
  },
  {
    "position": 414,
    "id": "card_414",
    "image": "train_Looking-Glass.png",
    "folder": "train-cards",
    "pack": "Pack5"
  },
  {
    "position": 415,
    "id": "card_415",
    "image": "train_Lozen.png",
    "folder": "train-cards",
    "pack": "Pack5"
  },
  {
    "position": 416,
    "id": "card_416",
    "image": "train_Mangas-Coloradas.png",
    "folder": "train-cards",
    "pack": "Pack5"
  },
  {
    "position": 417,
    "id": "card_417",
    "image": "train_marco-polo.png",
    "folder": "train-cards",
    "pack": "Pack5"
  },
  {
    "position": 418,
    "id": "card_418",
    "image": "train_michelangelo.png",
    "folder": "train-cards",
    "pack": "Pack5"
  },
  {
    "position": 419,
    "id": "card_419",
    "image": "train_minamoto-yoritomo.png",
    "folder": "train-cards",
    "pack": "Pack5"
  },
  {
    "position": 420,
    "id": "card_420",
    "image": "train_minamoto-yoshitsune.png",
    "folder": "train-cards",
    "pack": "Pack5"
  },
  {
    "position": 421,
    "id": "card_421",
    "image": "train_miyamoto-musashi.png",
    "folder": "train-cards",
    "pack": "Pack5"
  },
  {
    "position": 422,
    "id": "card_422",
    "image": "train_Nana.png",
    "folder": "train-cards",
    "pack": "Pack5"
  },
  {
    "position": 423,
    "id": "card_423",
    "image": "train_napoleon-bonaparte.png",
    "folder": "train-cards",
    "pack": "Pack5"
  },
  {
    "position": 424,
    "id": "card_424",
    "image": "train_nikola-tesla.png",
    "folder": "train-cards",
    "pack": "Pack5"
  },
  {
    "position": 425,
    "id": "card_425",
    "image": "train_noh-master.png",
    "folder": "train-cards",
    "pack": "Pack5"
  },
  {
    "position": 426,
    "id": "card_426",
    "image": "train_oda-nobunaga.png",
    "folder": "train-cards",
    "pack": "Pack5"
  },
  {
    "position": 427,
    "id": "card_427",
    "image": "train_onmyoji-mystic.png",
    "folder": "train-cards",
    "pack": "Pack5"
  },
  {
    "position": 428,
    "id": "card_428",
    "image": "train_oscar-wilde.png",
    "folder": "train-cards",
    "pack": "Pack5"
  },
  {
    "position": 429,
    "id": "card_429",
    "image": "train_Osceola.png",
    "folder": "train-cards",
    "pack": "Pack5"
  },
  {
    "position": 430,
    "id": "card_430",
    "image": "train_p-t-barnum.png",
    "folder": "train-cards",
    "pack": "Pack5"
  },
  {
    "position": 431,
    "id": "card_431",
    "image": "train_pablo-picasso.png",
    "folder": "train-cards",
    "pack": "Pack5"
  },
  {
    "position": 432,
    "id": "card_432",
    "image": "train_Pontiac.png",
    "folder": "train-cards",
    "pack": "Pack5"
  },
  {
    "position": 433,
    "id": "card_433",
    "image": "train_prince-shotoku.png",
    "folder": "train-cards",
    "pack": "Pack5"
  },
  {
    "position": 434,
    "id": "card_434",
    "image": "train_Pushmataha.png",
    "folder": "train-cards",
    "pack": "Pack5"
  },
  {
    "position": 435,
    "id": "card_435",
    "image": "train_Quanah-Parker.png",
    "folder": "train-cards",
    "pack": "Pack5"
  },
  {
    "position": 436,
    "id": "card_436",
    "image": "train_rasputin.png",
    "folder": "train-cards",
    "pack": "Pack5"
  },
  {
    "position": 437,
    "id": "card_437",
    "image": "train_Red-Cloud.png",
    "folder": "train-cards",
    "pack": "Pack5"
  },
  {
    "position": 438,
    "id": "card_438",
    "image": "train_Roman-Nose.png",
    "folder": "train-cards",
    "pack": "Pack5"
  },
  {
    "position": 439,
    "id": "card_439",
    "image": "train_saito-hajime.png",
    "folder": "train-cards",
    "pack": "Pack5"
  },
  {
    "position": 440,
    "id": "card_440",
    "image": "train_sarutobi-sasuke.png",
    "folder": "train-cards",
    "pack": "Pack5"
  },
  {
    "position": 441,
    "id": "card_441",
    "image": "train_Sequoyah.png",
    "folder": "train-cards",
    "pack": "Pack5"
  },
  {
    "position": 442,
    "id": "card_442",
    "image": "train_Sir-Agravaine-the-Proud.png",
    "folder": "train-cards",
    "pack": "Pack5"
  },
  {
    "position": 443,
    "id": "card_443",
    "image": "train_Sir-Balin-le-Savage.png",
    "folder": "train-cards",
    "pack": "Pack5"
  },
  {
    "position": 444,
    "id": "card_444",
    "image": "train_Sir-Bedivere-the-Bold.png",
    "folder": "train-cards",
    "pack": "Pack5"
  },
  {
    "position": 445,
    "id": "card_445",
    "image": "train_Sir-Bors-de-Ganis.png",
    "folder": "train-cards",
    "pack": "Pack5"
  },
  {
    "position": 446,
    "id": "card_446",
    "image": "train_Sir-Brandiles-the-Bold.png",
    "folder": "train-cards",
    "pack": "Pack5"
  },
  {
    "position": 447,
    "id": "card_447",
    "image": "train_Sir-Brunor-le-Noir-The-Black-Knight.png",
    "folder": "train-cards",
    "pack": "Pack5"
  },
  {
    "position": 448,
    "id": "card_448",
    "image": "train_Sir-Cador-of-Cornwall.png",
    "folder": "train-cards",
    "pack": "Pack5"
  },
  {
    "position": 449,
    "id": "card_449",
    "image": "train_Sir-Constantine-of-Britain.png",
    "folder": "train-cards",
    "pack": "Pack5"
  },
  {
    "position": 450,
    "id": "card_450",
    "image": "train_Sir-Dinadan-the-Humorous.png",
    "folder": "train-cards",
    "pack": "Pack5"
  },
  {
    "position": 451,
    "id": "card_451",
    "image": "train_Sir-Dodinas-le-Savage.png",
    "folder": "train-cards",
    "pack": "Pack6"
  },
  {
    "position": 452,
    "id": "card_452",
    "image": "train_Sir-Gaheris-of-Orkney.png",
    "folder": "train-cards",
    "pack": "Pack6"
  },
  {
    "position": 453,
    "id": "card_453",
    "image": "train_Sir-Galahad-the-Pure.png",
    "folder": "train-cards",
    "pack": "Pack6"
  },
  {
    "position": 454,
    "id": "card_454",
    "image": "train_Sir-Gareth-of-Orkney.png",
    "folder": "train-cards",
    "pack": "Pack6"
  },
  {
    "position": 455,
    "id": "card_455",
    "image": "train_Sir-Garlon-the-Invisible-Knight.png",
    "folder": "train-cards",
    "pack": "Pack6"
  },
  {
    "position": 456,
    "id": "card_456",
    "image": "train_Sir-Gawain-of-Orkney.png",
    "folder": "train-cards",
    "pack": "Pack6"
  },
  {
    "position": 457,
    "id": "card_457",
    "image": "train_Sir-Kay-the-Seneschal.png",
    "folder": "train-cards",
    "pack": "Pack6"
  },
  {
    "position": 458,
    "id": "card_458",
    "image": "train_Sir-Lamorak-de-Galis.png",
    "folder": "train-cards",
    "pack": "Pack6"
  },
  {
    "position": 459,
    "id": "card_459",
    "image": "train_Sir-Lancelot-du-Lac.png",
    "folder": "train-cards",
    "pack": "Pack6"
  },
  {
    "position": 460,
    "id": "card_460",
    "image": "train_Sir-Lucan-the-Butler.png",
    "folder": "train-cards",
    "pack": "Pack6"
  },
  {
    "position": 461,
    "id": "card_461",
    "image": "train_Sir-Marrok-the-Werewolf-Knight.png",
    "folder": "train-cards",
    "pack": "Pack6"
  },
  {
    "position": 462,
    "id": "card_462",
    "image": "train_Sir-Palamedes-the-Saracen.png",
    "folder": "train-cards",
    "pack": "Pack6"
  },
  {
    "position": 463,
    "id": "card_463",
    "image": "train_Sir-Pelleas-the-Gentle.png",
    "folder": "train-cards",
    "pack": "Pack6"
  },
  {
    "position": 464,
    "id": "card_464",
    "image": "train_Sir-Pelleas-the-Younger.png",
    "folder": "train-cards",
    "pack": "Pack6"
  },
  {
    "position": 465,
    "id": "card_465",
    "image": "train_Sir-Pellimore-the-Questing-Beast-Hunter.png",
    "folder": "train-cards",
    "pack": "Pack6"
  },
  {
    "position": 466,
    "id": "card_466",
    "image": "train_Sir-Percival-the-Welsh.png",
    "folder": "train-cards",
    "pack": "Pack6"
  },
  {
    "position": 467,
    "id": "card_467",
    "image": "train_Sir-Safir-the-Saracen.png",
    "folder": "train-cards",
    "pack": "Pack6"
  },
  {
    "position": 468,
    "id": "card_468",
    "image": "train_Sir-Segwarides-the-Jealous.png",
    "folder": "train-cards",
    "pack": "Pack6"
  },
  {
    "position": 469,
    "id": "card_469",
    "image": "train_Sir-Tor-the-Bastard.png",
    "folder": "train-cards",
    "pack": "Pack6"
  },
  {
    "position": 470,
    "id": "card_470",
    "image": "train_Sir-Tristan-of-Lyonesse.png",
    "folder": "train-cards",
    "pack": "Pack6"
  },
  {
    "position": 471,
    "id": "card_471",
    "image": "train_Sir-William-Marshal-1st-Earl-of-Pembroke.png",
    "folder": "train-cards",
    "pack": "Pack6"
  },
  {
    "position": 472,
    "id": "card_472",
    "image": "train_Sitting-Bull.png",
    "folder": "train-cards",
    "pack": "Pack6"
  },
  {
    "position": 473,
    "id": "card_473",
    "image": "train_sohei-monk.png",
    "folder": "train-cards",
    "pack": "Pack6"
  },
  {
    "position": 474,
    "id": "card_474",
    "image": "train_spartacus.png",
    "folder": "train-cards",
    "pack": "Pack6"
  },
  {
    "position": 475,
    "id": "card_475",
    "image": "train_sumo-champion.png",
    "folder": "train-cards",
    "pack": "Pack6"
  },
  {
    "position": 476,
    "id": "card_476",
    "image": "train_takeda-shingen.png",
    "folder": "train-cards",
    "pack": "Pack6"
  },
  {
    "position": 477,
    "id": "card_477",
    "image": "train_tea-master.png",
    "folder": "train-cards",
    "pack": "Pack6"
  },
  {
    "position": 478,
    "id": "card_478",
    "image": "train_Tecumseh.png",
    "folder": "train-cards",
    "pack": "Pack6"
  },
  {
    "position": 479,
    "id": "card_479",
    "image": "train_Ten-Bears.png",
    "folder": "train-cards",
    "pack": "Pack6"
  },
  {
    "position": 480,
    "id": "card_480",
    "image": "train_tengu-master.png",
    "folder": "train-cards",
    "pack": "Pack6"
  },
  {
    "position": 481,
    "id": "card_481",
    "image": "train_theodore-roosevelt.png",
    "folder": "train-cards",
    "pack": "Pack6"
  },
  {
    "position": 482,
    "id": "card_482",
    "image": "train_tokugawa-ieyasu.png",
    "folder": "train-cards",
    "pack": "Pack6"
  },
  {
    "position": 483,
    "id": "card_483",
    "image": "train_uesugi-kenshin.png",
    "folder": "train-cards",
    "pack": "Pack6"
  },
  {
    "position": 484,
    "id": "card_484",
    "image": "train_v22.png",
    "folder": "train-cards",
    "pack": "Pack6"
  },
  {
    "position": 485,
    "id": "card_485",
    "image": "train_v25.png",
    "folder": "train-cards",
    "pack": "Pack6"
  },
  {
    "position": 486,
    "id": "card_486",
    "image": "train_v28.png",
    "folder": "train-cards",
    "pack": "Pack6"
  },
  {
    "position": 487,
    "id": "card_487",
    "image": "train_v35.png",
    "folder": "train-cards",
    "pack": "Pack6"
  },
  {
    "position": 488,
    "id": "card_488",
    "image": "train_v39.png",
    "folder": "train-cards",
    "pack": "Pack6"
  },
  {
    "position": 489,
    "id": "card_489",
    "image": "train_v46.png",
    "folder": "train-cards",
    "pack": "Pack6"
  },
  {
    "position": 490,
    "id": "card_490",
    "image": "train_v61.png",
    "folder": "train-cards",
    "pack": "Pack6"
  },
  {
    "position": 491,
    "id": "card_491",
    "image": "train_v62.png",
    "folder": "train-cards",
    "pack": "Pack6"
  },
  {
    "position": 492,
    "id": "card_492",
    "image": "train_v63.png",
    "folder": "train-cards",
    "pack": "Pack6"
  },
  {
    "position": 493,
    "id": "card_493",
    "image": "train_v64.png",
    "folder": "train-cards",
    "pack": "Pack6"
  },
  {
    "position": 494,
    "id": "card_494",
    "image": "train_v68.png",
    "folder": "train-cards",
    "pack": "Pack6"
  },
  {
    "position": 495,
    "id": "card_495",
    "image": "train_v69.png",
    "folder": "train-cards",
    "pack": "Pack6"
  },
  {
    "position": 496,
    "id": "card_496",
    "image": "train_v70.png",
    "folder": "train-cards",
    "pack": "Pack6"
  },
  {
    "position": 497,
    "id": "card_497",
    "image": "train_v71.png",
    "folder": "train-cards",
    "pack": "Pack6"
  },
  {
    "position": 498,
    "id": "card_498",
    "image": "train_v72.png",
    "folder": "train-cards",
    "pack": "Pack6"
  },
  {
    "position": 499,
    "id": "card_499",
    "image": "train_v73.png",
    "folder": "train-cards",
    "pack": "Pack6"
  },
  {
    "position": 500,
    "id": "card_500",
    "image": "train_v74.png",
    "folder": "train-cards",
    "pack": "Pack6"
  },
  {
    "position": 501,
    "id": "card_501",
    "image": "train_v75.png",
    "folder": "train-cards",
    "pack": "Pack6"
  },
  {
    "position": 502,
    "id": "card_502",
    "image": "train_v76.png",
    "folder": "train-cards",
    "pack": "Pack6"
  },
  {
    "position": 503,
    "id": "card_503",
    "image": "train_v77.png",
    "folder": "train-cards",
    "pack": "Pack6"
  },
  {
    "position": 504,
    "id": "card_504",
    "image": "train_v78.png",
    "folder": "train-cards",
    "pack": "Pack6"
  },
  {
    "position": 505,
    "id": "card_505",
    "image": "train_v79.png",
    "folder": "train-cards",
    "pack": "Pack6"
  },
  {
    "position": 506,
    "id": "card_506",
    "image": "train_v80.png",
    "folder": "train-cards",
    "pack": "Pack6"
  },
  {
    "position": 507,
    "id": "card_507",
    "image": "train_v81.png",
    "folder": "train-cards",
    "pack": "Pack6"
  },
  {
    "position": 508,
    "id": "card_508",
    "image": "train_v82.png",
    "folder": "train-cards",
    "pack": "Pack6"
  },
  {
    "position": 509,
    "id": "card_509",
    "image": "train_v83.png",
    "folder": "train-cards",
    "pack": "Pack6"
  },
  {
    "position": 510,
    "id": "card_510",
    "image": "train_v84.png",
    "folder": "train-cards",
    "pack": "Pack6"
  },
  {
    "position": 511,
    "id": "card_511",
    "image": "train_v85.png",
    "folder": "train-cards",
    "pack": "Pack6"
  },
  {
    "position": 512,
    "id": "card_512",
    "image": "train_v86.png",
    "folder": "train-cards",
    "pack": "Pack6"
  },
  {
    "position": 513,
    "id": "card_513",
    "image": "train_v88.png",
    "folder": "train-cards",
    "pack": "Pack6"
  },
  {
    "position": 514,
    "id": "card_514",
    "image": "train_Victorio.png",
    "folder": "train-cards",
    "pack": "Pack6"
  },
  {
    "position": 515,
    "id": "card_515",
    "image": "train_vincent-van-gogh.png",
    "folder": "train-cards",
    "pack": "Pack6"
  },
  {
    "position": 516,
    "id": "card_516",
    "image": "train_wild-bill-hickok.png",
    "folder": "train-cards",
    "pack": "Pack6"
  },
  {
    "position": 517,
    "id": "card_517",
    "image": "train_wolfgang-amadeus-mozart.png",
    "folder": "train-cards",
    "pack": "Pack6"
  },
  {
    "position": 518,
    "id": "card_518",
    "image": "train_yamabushi-alt.png",
    "folder": "train-cards",
    "pack": "Pack6"
  },
  {
    "position": 519,
    "id": "card_519",
    "image": "train_yamabushi.png",
    "folder": "train-cards",
    "pack": "Pack6"
  },
  {
    "position": 520,
    "id": "card_520",
    "image": "train_zen-monk.png",
    "folder": "train-cards",
    "pack": "Pack6"
  }
];

export const getCardByPosition = (position) => {
    return STATIC_CARD_ORDER.find(card => card.position === position);
};

export const getImagePathByPosition = (position) => {
    const card = getCardByPosition(position);
    if (!card) return null;
    return `/assets/cards/${card.folder}/${card.image}`;
};

export const getTotalCardCount = () => {
    return STATIC_CARD_ORDER.length;
};

export const getPackByPosition = (position) => {
    const card = getCardByPosition(position);
    return card ? card.pack : null;
};

// Get all cards in a specific folder
export const getCardsByFolder = (folderName) => {
    return STATIC_CARD_ORDER.filter(card => card.folder === folderName);
};

// Get cards by pack
export const getCardsByPack = (packName) => {
    return STATIC_CARD_ORDER.filter(card => card.pack === packName);
};

console.log('Static Card Mapping Loaded');
console.log(`Total Cards: ${getTotalCardCount()}`);
console.log('Card Distribution:');
console.log('battle-cards:', getCardsByFolder('battle-cards').length);
console.log('build-cards:', getCardsByFolder('build-cards').length);
console.log('move-cards:', getCardsByFolder('move-cards').length);
console.log('train-cards:', getCardsByFolder('train-cards').length);
